import { render, staticRenderFns } from "./win2.vue?vue&type=template&id=accc6de6&"
import script from "./win2.vue?vue&type=script&lang=js&"
export * from "./win2.vue?vue&type=script&lang=js&"
import style0 from "./win2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports